import { render, staticRenderFns } from "./user-report-table.vue?vue&type=template&id=5506dab8&"
import script from "./user-report-table.vue?vue&type=script&lang=ts&"
export * from "./user-report-table.vue?vue&type=script&lang=ts&"
import style0 from "./user-report-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports